import React from "react";
import { Select } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const MultiSelectField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <Select
          multiple
          value={input.value || []}
          minH="120px"
          isDisabled={disabled}
          onChange={(event) =>
            input.onChange(Array.from(event.target.selectedOptions).map((option) => option.value))
          }
        >
          {(field.options || [])
            .filter((option) => option.active !== false)
            .map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </Select>
      </FieldFrame>
    )}
  />
);

export default MultiSelectField;
